import { ApplicationConfig, importProvidersFrom, Injectable, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ToastrModule } from 'ngx-toastr';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { loggerInterceptor } from './auth/logger.interceptor';
import { provideClientHydration } from '@angular/platform-browser';
import { AuthInterceptor } from './auth/auth.interceptor';

@Injectable()
export class TranslationLoader implements TranslateLoader {
  constructor(private http: HttpClient) { }
  apiURL = environment.apiURL;

  getTranslation(lang: string): Observable<any> {
    let lan: any = localStorage.getItem('locale')
    let data = {
      language: lan
    };
    return this.http.get(`${this.apiURL}translations/web/${lang}`).pipe(
      map(
        (res: any) => {
          return res;
        }
      )
    );
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: loggerInterceptor,
      multi: true,
    },
    provideZoneChangeDetection({ eventCoalescing: true }), 
    importProvidersFrom(
      BrowserAnimationsModule, // required animations module
      ToastrModule.forRoot({
        maxOpened: 5,
        autoDismiss: true, 
        positionClass: 'toast-bottom-right',
      }),
      TranslateModule.forRoot({
        // defaultLanguage: 'en',
        defaultLanguage: localStorage.getItem('locale') ?? 'de',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })
    ),
  ]
};

export function HttpLoaderFactory(http: HttpClient) {
  // return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  return new TranslationLoader(http);
}